import { Store as e } from "@tanstack/store";
//#region src/editor/managers/ExtensionManager/symbol.ts
var t = Symbol("originalFactory");
//#endregion
//#region src/editor/BlockNoteExtension.ts
function n(e) {
	if (typeof e == "object" && "key" in e) return function n() {
		return e[t] = n, e;
	};
	if (typeof e != "function") throw Error("factory must be a function");
	return function n(r) {
		return (i) => {
			let a = e({
				editor: i.editor,
				options: r
			});
			return a[t] = n, a;
		};
	};
}
function r(t, n) {
	return new e(t, n);
}
//#endregion
export { r as n, t as r, n as t };

//# sourceMappingURL=BlockNoteExtension-BXhE27K9.js.map